import Modal from "/WebInterface/new-ui/modules/modal.js";
import { growl } from "/WebInterface/new-ui/modules/toast.js";
import { _$ } from "/WebInterface/new-ui/assets/js/utils/dom.js";
import { shareDetailsMatchingTemplate } from "/WebInterface/new-ui/manage-shares/modules/modals/select-matching-accounts/template.js";
import { t } from "/WebInterface/new-ui/modules/localizations/localizations.js";
import { translateComponent } from "/WebInterface/new-ui/modules/localizations/localizations.js";
import store from "/WebInterface/new-ui/manage-shares/js/reducer.js";

export const initMatchingModal = (title, value, field_name, parent_dialog) => {
  const dialog = new Modal({
    title: "selectMatchingAccounts",
    body: shareDetailsMatchingTemplate({
      title,
      value: typeof value === "string" ? value : "",
      exactMatchText: t("exactMatch"),
      titleText: t("selectShareAccountWithTypeLike", {
        type: title,
      }),
    }),
    hasResizeOption: true,
    movable: true,
    uniqueId: "manage-shares-matching-share-modal",
    minWidth: "650px",
    minHeight: "320px",
    translateComponentMethod: translateComponent,
    buttons: [
      {
        label: "cancel",
        close: true,
        classes: ["primary-button", "is-bordered"],
        onClick: () => {},
      },
      {
        label: "ok",
        classes: ["primary-button", "ml-3"],
        onClick: async () => {
          const value = _$("#select_matching_items_value").val();
          const exact_match = _$("#exact_match").el()?.checked;
          const key = field_name;

          let hasmatchingItems = false;

          const selectedItems = store?.shareList?.map((item) => {
            const itemValue = item[key];

            const conditionMatch = exact_match
              ? value === itemValue
              : typeof itemValue === "string" &&
                itemValue?.toLowerCase()?.includes(value?.toLowerCase());

            if (conditionMatch && !hasmatchingItems) hasmatchingItems = true;

            return {
              ...item,
              checked: conditionMatch,
            };
          });

          if (!hasmatchingItems) {
            growl("", t("noMatchingAccountFound"), 5000, true);
            return;
          }

          store.dispatch("selectItemsWithSameKeyValuePair", selectedItems);
          dialog?.hide(true);
          parent_dialog?.hide(true);
        },
      },
    ],
  });
};
